import { FC } from "react";
import { useParams } from "react-router-dom";
import { useGetAssignmentLogsQuery } from "../productsApi";
import { formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import {useGetEnumsQuery} from "../../../app/globalApi";
import {getEnumValueByConstant} from "../../../helpers/utils/Utils";

interface props {
    productId?: string
}


const AssociationContactForm: FC<props> = ({ productId }) => {

    const { orderId } = useParams();
    const { data: assignmentLogsData } = useGetAssignmentLogsQuery(orderId);
    const { data: enums } = useGetEnumsQuery("");

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                <h5 className="font-semibold text-surface-0">Assignment Logs ({assignmentLogsData?.length || 0})</h5>
            </div>
            <div className={"p-2"}>

                <div className={"bg-text-0 border-2 border-[rgba(0,0,0,0.1)] rounded max-h-[150px] overflow-auto scrollbar-hide"}>
                    <table className="w-full">
                        <thead className="border-b-2 border-[rgba(0,0,0,0.1)]   ">
                            <tr>
                                {["Product Type", "Assigned To", "Assigned By", "Assigned To", "Reason"].map((heading) => (
                                    <th key={heading} className="p-2 text-left font-medium">{heading}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>

                            {assignmentLogsData?.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-surface-0 p-2">
                                       No Assignment logs to display
                                    </td>
                                </tr>
                            ) : (
                                assignmentLogsData?.map((data: any) => (

                                    <tr key={data.id} className="bg-text-0 border-b border-b-surface-5">
                                        <td className="p-2">{data.productId}</td>
                                        <td> {data.assigneeId == null || data.assigneeId === "" ? '-' : `${data.assigneeId} (${getEnumValueByConstant(enums?.["AssigneeType"], data.assigneeType)})`}</td>

                                        <td className="p-2">{data.assignedBy}</td>
                                        <td className="p-2">{formatValueAsDateAndTime(data.assignedDate)}</td>
                                        <td className="p-2">{data.reason}</td>
                                    </tr>
                                ))
                            )}

                        </tbody>



                    </table>
                </div>
            </div >
        </div>

    );
};

export default AssociationContactForm;
